export const PLAYSTORE_HUBBLE_APP_URL =
  "https://play.google.com/store/apps/details?id=money.myhubble";

export const APP_STORE_HUBBLE_APP_URL =
  "https://apps.apple.com/us/app/hubble-shopping-discounts-app/id1614427933?itsct=apps_box_badge&itscg=30200";

export const ErrorMessage = {
  SECURITY_CHECK_FAILED:
    "Security check failed. Please try again. If the issue persists, contact support.",
};

export const HUBBLE_MIXPANEL_ID = "dc68a30ad6651492cc20dfde4fc434a8";

export const TD_MIXPANEL_PROJECT_TOKEN = "1a02a8df5b026b4733528d351630f248";
